// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2zKrl","productName":"Table_productName__yALBh"};